<div class="outer-content">

<div class="float-left bg-white wh-auto">
  <div class="backbtn" *ngIf="!loginDetail || !loginDetail.customer.registrationStatus">
    <app-content-top-nav [visibleBackNav]='true' [enableBackNav]='true' (click)="backToRegistration()"></app-content-top-nav>
  </div>
<form class="form-group" [formGroup]="guidanceandAdviceForm" autocomplete="off" role="form" class="fieldHeight">
  <div *ngIf="contentData && CMSData" class="float-left bg-white card-background1 wh-auto">
    <!-- <app-content-top-nav [visibleBackNav]='false' [enableBackNav]='true'></app-content-top-nav> -->
    <div class="col-md-12 clear-all title-wrapper">
      <h1 class="title-text custom-header-h2 responsive-text-8" id="guidanceAndAdvice-header">{{contentData.header}}</h1>
    </div>
    <div class="col-md-12 clear-all content-wrapper">
      <!-- <p *ngIf="isFutureDate" class="content-top" id="content-date">Your Pension Wise appointment is scheduled for {{appmntDate}}</p> -->
      <div class="content" id="top-content" [innerHTML]="contentData.string_ByDefaultContent">
        <!-- {{contentData.string_ByDefaultContent}} -->
      </div>
    </div>
    <div class="col-md-12 wrapperMargin content-wrapper ">
      <div class="col-md-12 clear-all margin-top-30">
        <div class="col-md-9 clear-all" *ngIf="isBookedDate || isCaseBookMyOwn">
          <app-dropdown [pageName]="'guidanceAndAdvice'" (onChangeHandler)="secondQuestionChange(true)"
            [dropdownConfig]="guidanceAdviceConfig2" [controlName]="'attendedPensionWiseAppointmentQuestion'"
            [parent]="guidanceandAdviceForm">
          </app-dropdown>
        </div>
        <div *ngIf="(guidanceandAdviceForm.controls.attendedPensionWiseAppointmentQuestion.value === 'AE' || guidanceandAdviceForm.controls.attendedPensionWiseAppointmentQuestion.value === 'AC') && (isBookedDate || isCaseBookMyOwn) && !isFutureDate">
          <div class="col-md-12 clear-all title-wrapper" style="border: none; margin-bottom: 65px !important">
            <h1 class="" id="guidanceAndAdvice-header">{{contentData.header_reBook}}</h1>
          </div>
          <div class="col-md-12 clear-all pb-35">
            <div [innerHTML]="contentData.string_noWithoutGuidance"></div>
          </div>
        </div>
        <div class="col-md-9 clear-all"
          *ngIf="(isFirstQuestion || guidanceandAdviceForm.controls.attendedPensionWiseAppointmentQuestion.value === 'AE' || guidanceandAdviceForm.controls.attendedPensionWiseAppointmentQuestion.value === 'AC') && !isFutureDate">
          <app-dropdown [pageName]="'guidanceAndAdvice'" (onChangeHandler)="firstQuestionChange(true)"
            [dropdownConfig]="guidanceAdviceConfig1" [controlName]="'bookPensionWiseAppointmentQuestion'"
            [parent]="guidanceandAdviceForm">
          </app-dropdown>
        </div>
      </div>
      <div *ngIf="isInfoBlock" class="col-md-12 margin-top-30 bg-lightblue">
        <div [innerHTML]="contentData.string_ByDefaultInfoBlock"></div>
      </div>
      <div class="col-md-12 underline margin-top"></div>
      <app-content-bottom-nav [disabled]="isDisabledCTA" (onNextHandler)="gotoNextPage()"
        [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'"></app-content-bottom-nav>
    </div>
  </div>
</form>
</div> 

</div>